import React from "react";
import '../MobileConfirmPopup/MobileConfirmPopup.css'

const MobileConfirmPopup = ({ show, message, type = "success", onClose }) => {
  if (!show) return null;

  return (
    <div className="mobile-popup-overlay">
      <div className={`mobile-popup-box ${type}`}>
        <p>{message}</p>
        <button onClick={onClose}>OK</button>
      </div>
    </div>
  );
};

export default MobileConfirmPopup;